import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

/**
 *  TÖBB INTÉZMÉNY, TÖBB RENDSZER – a két átmeneti oldal (backend/tobbintezmeny.js).
 *   - /tobbintezmeny/megerosit  (a MÁSIK rendszerben): a felhasználó itt be van lépve; jóváhagyja, hogy a
 *     kérő rendszer megkapja az itteni intézményei listáját → aláírt igazolás, vissza a kérő rendszerbe.
 *   - /tobbintezmeny/kesz       (a SAJÁT rendszerben): az igazolás rögzítése, utána vissza a kezdőlapra.
 */
@Component({
  selector: 'app-tobbintezmeny',
  standalone: true,
  imports: [CommonModule],
  template: `
  <div style="max-width:560px;margin:60px auto;padding:20px;font-family:inherit;font-size:14px;line-height:1.5">
    <ng-container *ngIf="mod === 'megerosit'">
      <h2 style="font-size:20px">Hozzáférés egy másik rendszerből</h2>
      <p *ngIf="!igazolas && !hiba">Ellenőrzés…</p>
      <ng-container *ngIf="igazolas">
        <p>A(z) <b>{{ kero }}</b> rendszer (<code>{{ visszaOrigo }}</code>) szeretné megjeleníteni az intézményváltójában ezeket az intézményeidet:</p>
        <ul><li *ngFor="let i of igazolas.intezmenyek">{{ i.nev }}</li></ul>
        <p style="color:#667085;font-size:12.5px">Csak az intézmények neve megy át. Ha ott közülük választasz, ez a rendszer nyílik meg, a saját bejelentkezéseddel és jogaiddal.</p>
        <div style="display:flex;gap:10px">
          <button type="button" (click)="engedelyez()" style="border:0;border-radius:8px;padding:8px 16px;font-weight:600;background:#0f766e;color:#fff;cursor:pointer">Engedélyezés</button>
          <button type="button" (click)="megse()" style="border:1px solid #d0d5dd;border-radius:8px;padding:8px 16px;background:#fff;cursor:pointer">Mégse</button>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="mod === 'kesz'">
      <h2 style="font-size:20px">Másik rendszer hozzáadása</h2>
      <p *ngIf="!hiba && !kesz">Rögzítés…</p>
      <p *ngIf="kesz">Kész – a másik rendszer intézményei ({{ kesz }}) megjelentek az intézményváltóban. <a href="/">Tovább</a></p>
    </ng-container>
    <p *ngIf="hiba" style="color:#b42318">{{ hiba }}</p>
  </div>`,
})
export class TobbintezmenyComponent implements OnInit {
  mod: 'megerosit' | 'kesz' = 'megerosit';
  igazolas: any = null;
  hiba = '';
  kesz = '';
  kero = '';
  visszaOrigo = '';
  private vissza = '';
  private nonce = '';

  constructor(private http: HttpClient, private route: ActivatedRoute, private router: Router) {}

  async ngOnInit() {
    this.mod = this.route.snapshot.data['mod'] === 'kesz' ? 'kesz' : 'megerosit';
    if (this.mod === 'megerosit') {
      const p = this.route.snapshot.queryParamMap;
      this.nonce = p.get('nonce') || ''; this.vissza = p.get('vissza') || ''; this.kero = p.get('kero') || '';
      try { this.visszaOrigo = new URL(this.vissza).origin; } catch { this.hiba = 'Hibás visszatérési cím.'; return; }
      try { this.igazolas = await firstValueFrom(this.http.post('/api/tobbintezmeny/igazolas', { nonce: this.nonce, vissza: this.vissza })); }
      catch (e: any) { this.hiba = e?.error?.error || 'Az igazolás nem készült el.'; }
    } else {
      try {
        const frag = new URLSearchParams(window.location.hash.replace(/^#/, ''));
        const boritek = JSON.parse(decodeURIComponent(escape(atob((frag.get('b') || '').replace(/-/g, '+').replace(/_/g, '/')))));
        history.replaceState(null, '', window.location.pathname);
        const r: any = await firstValueFrom(this.http.post('/api/tobbintezmeny/rogzit', { boritek }));
        this.kesz = (r.intezmenyek || []).map((i: any) => i.nev).join(', ');
      } catch (e: any) { this.hiba = e?.error?.error || 'A rögzítés nem sikerült.'; }
    }
  }
  engedelyez() {
    const b = btoa(unescape(encodeURIComponent(JSON.stringify(this.igazolas.boritek)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    window.location.href = `${this.visszaOrigo}/tobbintezmeny/kesz#b=${b}`;
  }
  megse() { window.location.href = this.visszaOrigo || '/'; }
}
